module.exports = __webpack_public_path__ + "img/8.be016c17.png";